import { render, staticRenderFns } from "./CardEdit.vue?vue&type=template&id=de50b510&scoped=true&"
import script from "./CardEdit.vue?vue&type=script&lang=js&"
export * from "./CardEdit.vue?vue&type=script&lang=js&"
import style0 from "./CardEdit.vue?vue&type=style&index=0&id=de50b510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de50b510",
  null
  
)

export default component.exports